<template>
  <div class="wrap" v-if="options&&options.animationData" :style="{top:top,right:right}" @click="(e)=>$emit('click',e)">
    <Lottie
         v-if="options&&options.animationData"
         class="lottie-wrap"
        :options="options"
        :height="120"
        :width="120"
        @animCreated="(e)=>$emit('animCreated',e)"
    ></Lottie>
  </div>
</template>

<script>
import Lottie from 'vue-lottie/src/lottie.vue';
import axios from 'axios';
export default {
    name: 'index',
    components: { Lottie },
    props: ['lottieJson', 'position', 'size'],
    data() {
        return {
            options: {
                animationData: '',
                render: 'svg', // 要渲染的形式
                loop: true, // 是否重复
                autoplay: true // 是否自动启动},
            },
            height: '60px',
            width: '60px',
            top: 0,
            right: 0,
            resource: ''
        };

    },
    watch: {
        lottieJson: {
            handler: function (data) {
                console.log(data, 123123);
                if (!data) {
                    return;
                }
                this.resource = data;
                this.getLottieJson();
                // this.options = { ...this.options, ...data };
            },
            deep: true,
            immediate: true
        },
        position: {
            handler: function (value) {
                if (!value) return;
                const { top, right } = value;
                this.top = top;
                this.right = right;
            },
            deep: true,
            immediate: true
        }
    },
    created() {
        this.getLottieJson();
    },
    methods: {
        getLottieJson() {
            if (!this.resource) {
                return;
            }
            axios
                .get(this.resource, {
                    dataType: 'json',
                    crossDomain: true,
                    cache: false
                })
                .then(response => {
                    this.options.animationData = response.data;
                })
                .catch(function (error) {
                    // 请求失败处理
                    //     alert(error);
                });
        }
    }

};
</script>

<style lang="less" scoped>
.wrap {
  position: absolute;
  right: 0px;
  top: 0px;
  z-index: 199;
  width: 60px;
  height: 60px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
   image{
     width: 60px!important;
     height: 60px!important;
   }
  .lottie-wrap{
      //transform: scale(2.1);
  }
}
</style>